import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">
          Nigel's
          <span>Notebook</span>
        </div>
        <ul className="footer-links">
          <li><Link to="/articles">Articles</Link></li>
          <li><Link to="/help">Help &amp; Guides</Link></li>
          <li><Link to="/member/going-bias">Going Bias</Link></li>
          <li><Link to="/tools/trainer">Trainers</Link></li>
          <li><Link to="/tools/jockey">Jockeys</Link></li>
          <li><Link to="/tools/calculator">Calculator</Link></li>
          <li><Link to="/tools/drawdown">Bank Sizing</Link></li>
          <li><Link to="/privacy">Privacy</Link></li>
          <li><Link to="/cookies">Cookies</Link></li>
          <li><Link to="/terms">Terms &amp; Conditions</Link></li>
        </ul>
        <div className="footer-social">
          <a href="https://x.com/NNracingHQ" target="_blank" rel="noopener noreferrer" aria-label="Follow us on X (Twitter)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
          </a>
          <a href="https://bsky.app/profile/NNracingHQ.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Bluesky">
            <svg width="20" height="20" viewBox="0 0 568 501" fill="currentColor"><path d="M123.121 33.664C188.241 82.553 258.281 181.68 284 234.873c25.719-53.192 95.759-152.32 160.879-201.21C491.866-1.611 568-28.906 568 57.947c0 17.346-9.945 145.713-15.778 166.555-20.275 72.453-94.155 90.933-159.875 79.748C507.222 323.8 536.444 388.56 473.333 453.32c-119.86 122.992-172.272-30.859-185.702-70.281-2.462-7.227-3.614-10.608-3.631-7.733-.017-2.875-1.169.506-3.631 7.733-13.43 39.422-65.842 193.273-185.702 70.281-63.111-64.76-33.889-129.52 80.986-149.071-65.72 11.185-139.6-7.295-159.875-79.748C10.945 203.659 1 75.291 1 57.946 1-28.906 76.135-1.612 123.121 33.664z"/></svg>
          </a>
        </div>
      </div>
      <p className="footer-disclaimer">
        &copy; {new Date().getFullYear()} Nigel's Notebook. Gambling involves risk.
        Please bet responsibly. Past performance does not guarantee future results.
      </p>
    </footer>
  );
}
